/*
  Deporbox - soporte de "Menu transparente" para secciones hero de terceros
  (por ejemplo "SS - Hero pro").

  El tema Wonder solo aplica el desplazamiento negativo a sus propias
  secciones nativas (page-header-image-banner / -image-video / -logo-banner),
  que llevan ese script dentro. Este archivo hace lo mismo para un hero de
  otro tipo en dos situaciones:

    1) el hero esta dentro del Header Group, justo despues de la cabecera;
    2) el hero es la primera seccion de la plantilla de inicio, dentro de
       <main id="root">. Ahi es donde vive ahora el hero de Deporbox, para
       que no se repita en colecciones, productos y demas paginas.

  Fuera de la home no se aplica ningun desplazamiento: la cabecera se
  comporta como una barra normal encima del contenido.

  No hace nada si la cabecera no esta en modo "Menu transparente" o si la
  seccion siguiente ya es una de las nativas.
*/
(function () {
  var NATIVE_SELECTOR =
    'page-header-image-banner, page-header-image-video, page-header-logo-banner';

  var lastTarget = null;

  function getHeader() {
    return document.querySelector('header.page-header');
  }

  function isSection(el) {
    return !!(el && el.classList && el.classList.contains('shopify-section'));
  }

  function getTarget() {
    var header = getHeader();
    if (!header) return null;

    var el = header.nextElementSibling;
    while (el && el.tagName !== 'MAIN' && !isSection(el)) {
      el = el.nextElementSibling;
    }
    if (!el) return null;

    // 1) Hero dentro del Header Group.
    if (isSection(el)) {
      if (!el.classList.contains('shopify-section-group-header-group')) return null;
      if (el.querySelector(NATIVE_SELECTOR)) return null;
      return el;
    }

    // 2) Hero como primera seccion de la home.
    if (!document.body.classList.contains('template-index')) return null;

    var inner = el.firstElementChild;
    while (inner && !isSection(inner)) {
      inner = inner.nextElementSibling;
    }
    if (!inner) return null;
    if (inner.querySelector(NATIVE_SELECTOR)) return null;

    return inner;
  }

  function isTransparentHeaderEnabled() {
    var wtHeader = document.querySelector('.wt-header');
    return !!wtHeader && wtHeader.dataset.transparent === 'true';
  }

  function reset() {
    if (lastTarget) {
      lastTarget.style.marginTop = '';
      lastTarget = null;
    }
  }

  function apply() {
    var target = getTarget();

    if (lastTarget && lastTarget !== target) reset();

    if (!target || !isTransparentHeaderEnabled()) {
      reset();
      return;
    }

    var header = getHeader();
    if (!header) return;

    target.style.marginTop = '-' + header.offsetHeight + 'px';
    lastTarget = target;
  }

  function debounce(fn, wait) {
    var timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(fn, wait);
    };
  }

  function init() {
    apply();

    window.addEventListener('resize', debounce(apply, 150), { passive: true });
    window.addEventListener('load', apply);

    document.addEventListener('shopify:section:load', apply);
    document.addEventListener('shopify:section:unload', apply);
    document.addEventListener('shopify:section:reorder', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();